module.exports = __webpack_public_path__ + "static/media/img_goldfritz.1c3653e9.jpg";